import React, { useEffect, useState } from "react";
import "../styles/AdminDashboard.css";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function AdminDashboard() {
  const [houses, setHouses] = useState([]);
  const [stats, setStats] = useState({
    totalHouses: 0,
    totalPopulation: 0,
    totalPaid: 0,
    totalPending: 0
  });
  const [activeTab, setActiveTab] = useState("dashboard");

  // Form state for adding/editing house
  const [formData, setFormData] = useState({
    house_id: "",
    owner_name: "",
    member_count: 1,
    paid_amount: 0,
    total_amount: 0,
    status: "Pending"
  });
  const [editHouseId, setEditHouseId] = useState(null);

  // Fetch houses + stats
  const fetchHouses = () => {
    fetch("http://localhost/belpimpalgaon/api/get_houses.php")
      .then(res => res.json())
      .then(data => {
        setHouses(data.houses);
        setStats(data.stats);
      });
  };

  useEffect(() => {
    fetchHouses();
  }, []);

  // Chart
  const chartData = {
    labels: ["Total Houses", "Population", "Paid", "Pending"],
    datasets: [
      {
        label: "Statistics",
        data: [
          stats.totalHouses,
          stats.totalPopulation,
          stats.totalPaid,
          stats.totalPending
        ],
        backgroundColor: ["#4e73df","#1cc88a","#36b9cc","#e74a3b"]
      }
    ]
  };

  const chartOptions = { responsive: true, plugins: { legend: { display: false } } };

  // Handle add/edit house
  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiUrl = editHouseId ? "update_house.php" : "add_house.php";

    try {
      const res = await fetch(`http://localhost/belpimpalgaon/api/${apiUrl}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if(data.status === "success") {
        alert(editHouseId ? "Updated Successfully!" : "Added Successfully!");
        fetchHouses();
        setFormData({ house_id: "", owner_name: "", member_count: 1, paid_amount: 0, total_amount: 0, status: "Pending" });
        setEditHouseId(null);
        setActiveTab("dashboard");
      } else {
        alert(data.message);
      }
    } catch(err) {
      console.log(err);
      alert("Server Error");
    }
  };

  const handleEdit = (house) => {
    setFormData({ ...house });
    setEditHouseId(house.id);
    setActiveTab("addHouse");
  };

  return (
    <div className="admin-dashboard-container">

      {/* LEFT SIDEBAR */}
      <aside className="sidebar">
        <h2>ग्रामपंचायत</h2>
        <nav>
          <ul>
            <li onClick={() => setActiveTab("dashboard")}>🏠 Dashboard</li>
            <li onClick={() => setActiveTab("addHouse")}>🏡 नवीन घर जोडा</li>
            <li onClick={() => setActiveTab("members")}>👨‍👩‍👧 सदस्य माहिती</li>
            <li onClick={() => setActiveTab("payments")}>💧 पाणीपट्टी</li>
            <li onClick={() => setActiveTab("reports")}>📊 मासिक अहवाल</li>
            <li onClick={() => setActiveTab("notifications")}>🔔 Notifications</li>
            <li onClick={() => setActiveTab("scanner")}>📷 QR Scanner</li>
          </ul>
        </nav>
      </aside>

      {/* RIGHT CONTENT */}
      <main className="dashboard-main">
        <header>
          <h1>Admin Dashboard - बेलपिंपळगाव</h1>
        </header>

        {/* Stats Cards */}
        {activeTab === "dashboard" &&
        <>
        <div className="stats-cards">
          <div className="card blue">🏠 <h3>{stats.totalHouses}</h3><p>एकूण घरे</p></div>
          <div className="card green">👨‍👩‍👧 <h3>{stats.totalPopulation}</h3><p>एकूण लोकसंख्या</p></div>
          <div className="card cyan">💧 <h3>₹ {stats.totalPaid}</h3><p>भरलेली पाणीपट्टी</p></div>
          <div className="card red">⚠️ <h3>₹ {stats.totalPending}</h3><p>बाकी पाणीपट्टी</p></div>
        </div>

        {/* Graph */}
        <div className="chart-container">
          <Bar data={chartData} options={chartOptions} />
        </div>

        {/* Houses Table */}
        <section className="houses-table">
          <h2>घरांची यादी</h2>
          <table>
            <thead>
              <tr>
                <th>House ID</th>
                <th>Owner Name</th>
                <th>Members</th>
                <th>Paid</th>
                <th>Total</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {houses.map(house=>(
                <tr key={house.id}>
                  <td>{house.house_id}</td>
                  <td>{house.owner_name}</td>
                  <td>{house.member_count}</td>
                  <td>₹ {house.paid_amount}</td>
                  <td>₹ {house.total_amount}</td>
                  <td className={house.status==="Paid"?"paid":"pending"}>{house.status}</td>
                  <td><button onClick={()=>handleEdit(house)}>Edit</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        </>
        }

        {/* Add / Edit House Form */}
        {activeTab === "addHouse" &&
        <section className="form-section">
          <h2>{editHouseId ? "घर अपडेट करा" : "नवीन घर जोडा"}</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" placeholder="House ID" value={formData.house_id}
              onChange={e=>setFormData({...formData, house_id:e.target.value})} required />
            <input type="text" placeholder="Owner Name" value={formData.owner_name}
              onChange={e=>setFormData({...formData, owner_name:e.target.value})} required />
            <input type="number" placeholder="Member Count" value={formData.member_count}
              onChange={e=>setFormData({...formData, member_count:e.target.value})} required />
            <input type="number" placeholder="Paid Amount" value={formData.paid_amount}
              onChange={e=>setFormData({...formData, paid_amount:e.target.value})} />
            <input type="number" placeholder="Total Amount" value={formData.total_amount}
              onChange={e=>setFormData({...formData, total_amount:e.target.value})} />
            <select value={formData.status} onChange={e=>setFormData({...formData, status:e.target.value})}>
              <option value="Pending">Pending</option>
              <option value="Paid">Paid</option>
            </select>
            <button type="submit">{editHouseId ? "Update" : "Save"}</button>
          </form>
        </section>
        }

      </main>
    </div>
  );
}
